
export const SELECTED_ACCOUNT = {
    SET_ACCOUNT:'SELECTED_ACCOUNT.SET_ACCOUNT'
}